// extracted by mini-css-extract-plugin
module.exports = {"ButtonNext":"ButtonNext_ButtonNext__v5KPA","disabled":"ButtonNext_disabled__1sGl5"};